import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconEqualizerComponent } from "./med-icon-equalizer.component";

@NgModule({
  declarations: [
    MedIconEqualizerComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconEqualizerComponent,
  ],
})
export class MedIconEqualizerModule { }
